<template>
    <div class="col-md-12">
<!--         <form id="form-grille-audit-list" data-trigger-form>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Intitulé thème :</label>
                        <input id="theme" name="theme" class="form-control" type="text" placeholder="Rechercher un intitulé">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Date de création :</label>
                        <div class="input-group date" data-provide="datepicker" data-date-format="dd/mm/yyyy"
                        data-date-language="fr" data-date-autoclose="true" data-date-today-highlight="true">
                        <input id="dateCreation" name="dateCreation" class="form-control" type="text"
                        placeholder="jj/mm/aaaa" value="">
                        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>Date de dernière modification :</label>

                    <div class="input-group date" data-provide="datepicker" data-date-format="dd/mm/yyyy"
                    data-date-language="fr" data-date-autoclose="true" data-date-today-highlight="true">
                    <input id="dateDerniereMiseAJour" name="dateDerniereMiseAJour" class="form-control" type="text"
                    placeholder="jj/mm/aaaa" value="">
                    <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
                </div>
            </div>
        </div>
    </div>
</form> -->
        <h3 class="text-center">Liste des modèles de grille d'audit</h3>
        <router-link tag="button" class="btn btn-success" type="button" :to="{name: 'TemplateDefault'}">Editer le modèle par défaut</router-link>
        <router-link tag="button" class="btn btn-success" type="button" :to="{name: 'TemplateCreate'}">Créer une grille d’audit</router-link>
        <div id="grid-container-grille-audit-list">
            <div id="grilleAuditGrid__evolugrid_holder" style="position: relative">
                <div id="grilleAuditGrid">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Thème</th>
                                <th>Date de création</th>
                                <th>Date de dernière mise à jour</th>
                                <th>Liste session</th>
                                <th>Dupliquer</th>
        <!--                         <th>Thème <a href="#"><i class="fa fa-chevron-up" aria-hidden="true"></i></a> <a href="#"><i class="fa fa-chevron-down" aria-hidden="true"></i></a>
                                </th>
                                <th>Date de création <a href="#"><i class="fa fa-chevron-up" aria-hidden="true"></i></a> <a href="#"><i class="fa fa-chevron-down" aria-hidden="true"></i></a>
                                </th>
                                <th>Date de dernière mise à jour <a href="#"><i class="fa fa-chevron-up" aria-hidden="true"></i></a> <a href="#"><i class="fa fa-chevron-down" aria-hidden="true"></i></a>
                                </th>
                                <th>Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="template in auditTemplates" :key="template.id" :class="template.state == false ? 'warning' : ''">
                                <td ><router-link :to="{name: 'TemplateEdit', params: {templateId: template.id}}">{{ template.title + (template.state == false ? ' - INVALIDE : Changez de thème' : '')}}</router-link></td>
                                <td>{{ formatDate(template.createdAt) }}</td>
                                <td>{{ formatDate(template.updatedAt) }}</td>
                                <td>
                                    <router-link v-if="template.nbSessions" tag="button" class="btn btn-success" type="button" :to="{name: 'TemplateSessions', params: {templateId: template.id}}">{{ template.nbSessions + (template.nbSessions > 1 ? ' sessions' : ' session') }}</router-link>
                                    <span v-else>Aucune session</span>
                                </td>
                                <td><button type="button" class="btn btn-success" @click="duplicate(template.id, template.title)">Dupliquer</button></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="pager"></div>
                </div>
            </div>
        </div>
        <modalDuplicateTemplateBlock></modalDuplicateTemplateBlock>
    </div>
</template>


<script>
    import ModalDuplicateTemplateBlock from 'components/ModalDuplicateTemplateBlock';

    export default {
        components: {
            ModalDuplicateTemplateBlock
        },
        computed: {
            auditTemplates: function() {
                return this.$store.state.admin.templates;
            }

        },
        methods: {
            toggleUntoggle()  {
                this.showModal = !this.showModal;
            },
            formatDate(date)  {
                let d = new Date(date);
                return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear() + ' - ' + d.getHours() + ':' + d.getMinutes().toString().padStart(2, "0");
            },
            duplicate(id, label)	{
                this.$store.commit('TEMPLATE_ID_TO_DUPLICATE', id);
                this.$store.commit('TEMPLATE_LABEL_TO_DUPLICATE', label);
                this.$store.commit('DISPLAY_MODAL_DUPLICATE_TEMPLATE', true);
            }
        },
        data: function()  {
            return {
                showModal: false,
                cancelTextModal: "Annuler",
                okTextModal: "Créer"
            };
        }
    };
</script>

<style>


</style>
